import {collection, component, EntityData, field, identifier} from "@fedeltapointofsale/data-client";
import {SiteReferenceData} from "../site/site.data";
import {CategoryReferenceData} from "../../catalogue/category/category.data";
import {EmailSettingReferenceData} from "../../system/email-setting/email-setting.data";

export class WebTerminalType {
    public static readonly API: string = "API";
    public static readonly ONLINE: string = "ONLINE";
    public static readonly RESERVATION: string = "RESERVATION";
    public static readonly MOBILE_POS: string = "MOBILE POS";
    public static readonly TYRO: string = "TYRO";
    public static readonly EZYPAY: string = "EZYPAY";
    public static readonly TYRO_FOOD: string = "TYRO FOOD";
}

export class TyroWebTerminalData extends EntityData<TyroWebTerminalData> {
    @identifier id: number;
    @field terminalPassphrase: string;
}

export class EmailMessageData extends EntityData<EmailMessageData> {
    @field subject: string;
    @component emailSettings: EmailSettingReferenceData;
    @field customTemplate: boolean;
}

export class MessageData extends EntityData<MessageData> {
    @identifier id: number;
    @field content: string;
    @field messageType: string = "EMAIL";
    @component emailMessage: EmailMessageData;
}

export class WebTerminalData extends EntityData<WebTerminalData> {
    @identifier webTerminalId: number;
    @field webTerminalName: string;
    @field terminalId: number;
    @field terminalType: string;
    @field storeName: string;
    @field autoRefloat: boolean = true;
    @field autoBalance: boolean = true;
    @field posApplicationKey: string;
    @field posMerchantId: string;
    @field externalWebTerminalId: string;
    @field tyroFoodLocationId: string;
    @field tyroFoodRefreshToken: string;
    @field integrationName: string;
    @component site: SiteReferenceData;
    @component tyroInfo: TyroWebTerminalData;
    @component resetPasswordEmail: MessageData;
    @component orderReadyEmail: MessageData;
    @field sendOrderReadyEmail: boolean;
    @field sendOrderReadySms: boolean;
    @field sendTableOrderReady: boolean = false;
    @field autoConvertPickupToSale: boolean = true;
    @field autoConvertDeliveryToSale: boolean = true;
    @field mergeTableOrdersWithinMinutes: number;
    @collection(CategoryReferenceData) exportCategories: CategoryReferenceData[];
    @field suspendOrdering: boolean = false;
}

export class WebTerminalReferenceData extends EntityData<WebTerminalReferenceData> {
    @identifier webTerminalId: number;
    @field webTerminalName: string;
}
